 @if(isIframe && isGlobalSpinnerHidden){
    <p>authentication failed</p>
 }
